import { Link } from 'react-router-dom';
import { motion } from "framer-motion";

import Footer from '../components/Footer';

function Page404(){

    const LoadingTransition = { duration: 1, ease: [0.43, 0.13, 0.23, 0.96] };

    return(
        <div className="redirect">
            <motion.div 
                initial={{x:0}}
                animate={{x:'-100%'}}
                exit={{x:0}}
                transition={LoadingTransition}
                className="page-trans">
            </motion.div>
            <section id="heroSection" className="simple-hero section page-404">
                <div className="container-fluid-small">
                    <div className="row">

                        <div className="col-12">
                            <h6 className="sub-title">Page Not Found</h6>
                            <h1 className="big-title">ページが見つかりません</h1>
                            <Link to={'/'}>TOPに戻る</Link>
                        </div>

                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
    
}

export default Page404